import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@abp/ng.core';
import { AuthStateService } from './auth.signal';

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const authState = inject(AuthStateService);

  if (!authState.isAuthenticated()) {
    inject(Router).navigate(['/account/login']);
    return false;
  }

  const requiredPolicy = route.data?.['requiredPolicy'] as string | undefined;
  if (requiredPolicy && !authState.hasPermission(requiredPolicy)) {
    return inject(Router).parseUrl('/');
  }

  return true;
};
